import { createSelector } from '@ngrx/store';
import { getSpinnerStateSelector } from 'src/app/core/store/index';
import { isSpinnerActive } from 'src/app/core/store/reducers/spinner.reducer';

export const isSpinnerActiveSelector = createSelector(
  getSpinnerStateSelector,
  isSpinnerActive
);
